import { render, staticRenderFns } from "./orderListtoday.vue?vue&type=template&id=085dd2a0&scoped=true"
import script from "./orderListtoday.vue?vue&type=script&lang=js"
export * from "./orderListtoday.vue?vue&type=script&lang=js"
import style0 from "./orderListtoday.vue?vue&type=style&index=0&id=085dd2a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085dd2a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085dd2a0')) {
      api.createRecord('085dd2a0', component.options)
    } else {
      api.reload('085dd2a0', component.options)
    }
    module.hot.accept("./orderListtoday.vue?vue&type=template&id=085dd2a0&scoped=true", function () {
      api.rerender('085dd2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderListtoday.vue"
export default component.exports